import { useCallback, useState } from 'react';

/**
 * The asset revision to send with the next write. Each write answers the next revision; keeping the highest one
 * seen lets a second write go out before the asset has been read again.
 */
export function useRevision(assetRevision: number) {
  const [seen, setSeen] = useState(assetRevision);
  const saw = useCallback((answer: { revision: number }) => setSeen((prev) => Math.max(prev, answer.revision)), []);
  return { revision: Math.max(seen, assetRevision), saw };
}
